// Runtime env for the Seitiate+ frontend.
//
// Three bases talked to:
//   - VITE_SEITIATE_ENGINE_URL      -> the Seitiate engine (auth, tasks, sources,
//                                      providers, codex). Currently defaults to
//                                      the CES backend Cloud Run proxy until
//                                      Pavel's Elixir runtime becomes the
//                                      standalone serving point.
//   - VITE_SEITIATE_DESK_ENGINE_URL -> the Writing Desk's store, and ONLY the
//                                      `/api/v1/desk/*` family (rung M0). The
//                                      store lands on the Elixir substrate
//                                      (seitiate PR #224), which serves none of
//                                      the other engine routes, so the desk base
//                                      is its own setting. Unset or empty → the
//                                      engine URL, i.e. exactly today's routing.
//   - VITE_SEITIATE_PLUS_API_URL    -> this repo's backend (dashboard_layouts,
//                                      and eventually anything Seitiate+ specific).

const DEFAULT_SEITIATE_ENGINE_URL = 'https://ces-backend-331630083873.us-central1.run.app';

export const SEITIATE_ENGINE_URL: string =
  (import.meta.env.VITE_SEITIATE_ENGINE_URL as string | undefined) ??
  (import.meta.env.VITE_ENGINE_URL as string | undefined) ??
  DEFAULT_SEITIATE_ENGINE_URL;

// Back-compat alias for older imports. New engine consumers should import
// SEITIATE_ENGINE_URL so the future Seitiate cutover is named explicitly.
export const ENGINE_URL: string = SEITIATE_ENGINE_URL;

// A Docker build without the argument passes an EMPTY string, which `??` would
// keep as the base; only a non-empty value counts as configured.
function configuredBase(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim().replace(/\/+$/, '');
  return trimmed === '' ? undefined : trimmed;
}

// The desk store's base. Read by the desk store client alone
// (`features/desk/api/deskStore.ts`); every other engine consumer stays on
// SEITIATE_ENGINE_URL. The backend's SEITIATE_DESK_ENGINE_URL is the same seam
// on the server side and is what the readiness probe checks.
export const SEITIATE_DESK_ENGINE_URL: string =
  configuredBase(import.meta.env.VITE_SEITIATE_DESK_ENGINE_URL) ?? SEITIATE_ENGINE_URL;

export const PLUS_API_URL: string =
  (import.meta.env.VITE_SEITIATE_PLUS_API_URL as string | undefined) ??
  'http://localhost:8010';

// Pre-joined engine `/api/v1` base. Panels using raw fetch should import this
// instead of rebuilding it from a local env var — several settings panels
// previously declared `API_BASE = VITE_API_URL || ''`, fell through to a
// same-origin relative URL in production, and the static SPA host served
// `index.html` for `/api/v1/...` — producing `Unexpected token '<'` across
// the settings surface.
export const API_V1: string = `${SEITIATE_ENGINE_URL}/api/v1`;
